import type { ClaimNode } from '../../infrastructure/api-functions/patent-claim-api';

export type { ClaimNode } from '../../infrastructure/api-functions/patent-claim-api';

export interface PatentClaimService {
    /**
     * 获取专利权利要求
     */
    getPatentClaim(payload: {patentId: string, lang?: string}): Promise<string>;

    /**
     * 获取专利权利要求树
     */
    getPatentClaimsTree(patentId: string): Promise<ClaimNode[]>;
}

export const PatentClaimService = Symbol.for('PatentClaimService');
